import { combineReducers, createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import {reducer as notificationsReducer} from 'reapop';

import viewReducer from 'shared/reducers/view/web';
import sessionReducer from 'shared/reducers/session';
import debugReducer from 'shared/reducers/debug';
import draftReducer from 'shared/reducers/draft';



/*
 * Setup Redux store
 */
export default function(initialState = {}) {

  // Redux reducer
  const rootReducer = combineReducers({
    view: viewReducer,
    session: sessionReducer,
    debug: debugReducer,
    draft: draftReducer,

    notifications: notificationsReducer(),
  });

  // Redux middlewares
  let middlewares = [
    thunk,
  ];

  if (process.env.NODE_ENV !== 'production') {
    const loggerMid = createLogger();
    middlewares = [...middlewares, loggerMid];
  }

  // Redux store
  const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middlewares)
  );

  return store;
};



// WEBPACK FOOTER //
// ./src/helpers/initReduxStore.js